<div class="footer py-4 text-white">
    <div class="container ">
        <div class="row">
            <div class="col-12 col-md-3 col-xl-3 mt-4">
                <a class="d-block">
                    <img src="../../assets/icons/footer/logo-white.png" class="foot-logo"/>
                </a>
            </div>
            <div class="col-6 col-md-3 col-xl-3 mt-4">
                <h3 class="f-hino">Modelos</h3>
                <hr class="w-50"/>
                <ul class="foot-menu">
                    <li class="mb-3" routerLink="hino-300"><img src="../../assets/icons/footer/link-white.svg" class="foot-link-menu"/> Serie 300</li>
                    <li class="mb-3" routerLink="hino-500"><img src="../../assets/icons/footer/link-white.svg" class="foot-link-menu"/> Serie 500</li>
                    <li class="mb-3" routerLink="hino-700"><img src="../../assets/icons/footer/link-white.svg" class="foot-link-menu"/> Serie 700</li>
                </ul>
            </div>
            <div class="col-6 col-md-3 col-xl-3 mt-4">
                <h3 class="f-hino">Nosotros</h3>
                <hr class="w-50"/>
                <ul class="foot-menu">
                    <li class="mb-2"><a routerLink="sobre-nosotros">Sobre Nosotros</a></li>
                    <li class="mb-2"><a routerLink="sucursales">Sucursales</a></li>
                    <li class="mb-2"><a routerLink="contactenos">Contáctenos</a></li>
                </ul>
            </div>
            <div class="col-12 col-md-3 col-xl-3 mt-4">
                <h3 class="f-hino">Síguenos</h3>
                <div class="row">
                    <div class="col-6 col-md-12 col-xl-12">
                        <div class="d-flex">
                            <a href="https://www.facebook.com/HinoBolivia" target="_blank" class="d-block foot-link-rrss"><img src="../../assets/icons/footer/facebook.svg"/></a>
                            <a href="https://api.whatsapp.com/send?phone=+59177501134&text=Hola,%20estaba%20en%20la%20p%C3%A1gina%20web%20y%20tengo%20una%20consulta" class="d-block foot-link-rrss mx-4"><img src="../../assets/icons/footer/whatsapp.svg"/></a>
                        </div>
                    </div>
                    <div class="col-6 col-md-12 col-xl-12 text-end mt-4">
                        <a href="tel:591800175200" target="_blank"><img src="../../assets/icons/footer/cc.svg" class="foot-logo"/></a>
                    </div>
                </div>
                <div class="row">
                   
                </div>
            </div>
        </div>      
    </div>
    <hr/>
    <div class="container">
        <div class="row subfoot f-roboto">
            <div class="col-12 col-md-6 col-xl-6">
                © 2025 Hino Bolivia copyright. All rights reserved              
            </div>
            <div class="col-12 col-md-6 col-xl-6 text-end desktop">
                <a>Términos y condiciones</a>
            </div>
        </div>
    </div>
</div>